import { render, staticRenderFns } from "./project-address.vue?vue&type=template&id=0bd67ae2&"
import script from "./project-address.vue?vue&type=script&lang=js&"
export * from "./project-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports